import { Navigate, useLocation } from 'react-router';

export const MenuSpecialsRedirect = () => {
  const location = useLocation();
  const redirectPath = location.pathname.split('/specials');
  const redirectUrl = `${redirectPath[0]}/menu/specials`;

  return <Navigate to={redirectUrl} replace />;
};
